import { render } from "./CosmoCustomizeApp.vue?vue&type=template&id=2326e414&scoped=true"
import script from "./CosmoCustomizeApp.vue?vue&type=script&lang=js"
export * from "./CosmoCustomizeApp.vue?vue&type=script&lang=js"

import "./CosmoCustomizeApp.vue?vue&type=style&index=0&id=2326e414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2326e414"]])

export default __exports__